const form = (postType) => (
    `... on ${postType}_Components_Components_Form {
        fieldGroupName
        title
        subtitle
        content
        formType
        hubspotFormRegionCode
        hubspotFormPortalId
        hubspotFormId
        settings {
            layout
            showComponentTitle
            componentTitle
            spacing
            theme
        }
    }`
);

export default form;
